    import React, {Component} from 'react';
    import { NavLink, Switch, Route, Link } from 'react-router-dom';
    import { Dimmer,Loader,Progress } from 'semantic-ui-react';
    import Home from './components/Home.js';
    import Recorder from './components/Recorder.js';
    import Validate from './components/Validate.js';
    import Video from './components/Video.js';
    import Entry from './components/Entry.js';
    import Search from './components/Search.js';
    import ZoomSearch from './components/ZoomSearch.js';
    import Report from './components/Report.js';
    import Legend from './components/Legend.js';    
    import ZoomList from './components/ZoomList.js';
    import 'semantic-ui-css/semantic.min.css'
    import './App.css';
    import './fonts/aamay24.ttf';
    // import { siuTable } from './components/info/siuTable.js';
    import { LazyLoadImage } from 'react-lazy-load-image-component';
    import 'react-lazy-load-image-component/src/effects/blur.css';
    import axios from 'axios';
    // import ReactGA from "react-ga4";
    export const API_URL = "https://www.inupiaqonline.com/fastapi/";
    // export const API_URL = "http://0.0.0.0:5001/";

    // export const WEB_URL = "http://localhost:3000";
    // export const WEB_URL = "http://inupiaqonline.com/kyukwow";
    // export const API_URL = "https://inupiaqonline.com/api";
    // ReactGA.initialize("G-JZB9CXH4GJ")

    export const WEB_URL = "http://localhost:3000";
     // export const WEB_URL = "https://www.kissaq.com/language-resources/";
     // export const API_URL = "https://inupiaqonline.com/api";


    // const customFont = 'var(--secondaryHeadlineFont),Arial,Helvetica,sans-serif;'


    // const Navigation = () => (
    //   <Menu inverted>
    //     <Menu.Item
    //       name='home'
    //       active={activeItem === 'home'}
    //       onClick={this.handleItemClick}
    //     />
    //     <Menu.Item
    //       name='categories'
    //       active={activeItem === 'categories'}
    //       onClick={this.handleItemClick}
    //     />
    //   </Menu>
    // );
    let audiolibrary = [];
    let combinedAudioList = [];
    let combinedDictionaryList = []
    let dictionary = [];
    let dictionarydict = {};
    let postbasedictionary = []
    let postbasedictionarydict = {}
    let allsugtstundata = []

    let siuSearchList = []
    let totaldata = {}

    class App extends React.Component {
      constructor(props) {
        super(props);
        this.state = {
          count:0,
          activeItem: 'home',
          dictionary:[],
          dictionarydict:{},
          audioOnly:false,
          audiolibrary:[],
          audiolibraryinterview:[],
          audiolibraryscripted:[],
          innerWidth: document.documentElement.clientWidth,
          innerHeight: document.documentElement.clientHeight,
          siuTable: {},
          siuSearchList: [],
          zoomSearchList: [],
          inupiaqPopups:{},
          videoList:{},
          srts:{},
          allfilters:{},
        };
        this.updateDimensions = this.updateDimensions.bind(this);
        this.audioHandler = this.audioHandler.bind(this)

      }

      componentDidMount() {
        console.log('componentDidMount')
        window.addEventListener("resize", this.updateDimensions);

        if (audiolibrary.length === 0) {
          axios
            .get(API_URL + "allsugtstundata", {
              onDownloadProgress: (progressEvent) => {
                // const totalLength = progressEvent.lengthComputable ? progressEvent.total : progressEvent.target.getResponseHeader('content-length') || progressEvent.target.getResponseHeader('x-decompressed-content-length');
                // console.log("onDownloadProgress3", totalLength);
                // if (totalLength !== null) {
                // this.setState({progressData3:Math.round( progressEvent.loaded )})
                  // this.progressData3 = Math.round( (progressEvent.loaded * 100) / totalLength );
                  // console.log(this.progressData3)
                // }
              },
            }).then(response => {
              allsugtstundata = response.data;
              // console.log('Fetched AudioLibrary');
              // console.log(allsugtstundata)
              combinedAudioList = [...allsugtstundata['interview'], ...allsugtstundata['scripted']];
              combinedDictionaryList = [...allsugtstundata['dictionaryRest'], ...allsugtstundata['dictionaryPostbases']];
              dictionary = []
              // console.log('combinedList',combinedList)
              // let phrasebookaudio = []
              // let conversational = []
              // let examplesentenceaudio = []
              combinedDictionaryList.map((k,index)=> {
                dictionarydict[k['s']]=k
                dictionarydict[k['s']]['english'] = k['e'].join("; ")
                dictionarydict[k['s']]['sugtstun'] = k['s']
              })

              allsugtstundata['dictionaryPostbases'].map((k,index)=> {
                postbasedictionarydict[k['s']]=k
                postbasedictionarydict[k['s']]['english'] = k['e'].join("; ")
                postbasedictionarydict[k['s']]['sugtstun'] = k['s']
              })

              Object.keys(dictionarydict).map((k)=>{
                dictionary.push(dictionarydict[k])
              })
              Object.keys(postbasedictionarydict).map((k)=>{
                postbasedictionary.push(postbasedictionarydict[k])
              })
                // audiolibrary[index]['tnormal'] = audiolibrary[index]['t'].join(" ").replaceAll('k̲','k').replaceAll('x̲','x').replaceAll('«','').replaceAll('«','').replaceAll('»','').replaceAll('»','')
                // audiolibrary[index]['tnormal'] = audiolibrary[index]['t'].join(" ").replaceAll('«','').replaceAll('«','').replaceAll('»','').replaceAll('»','')
                // audiolibrary[index]['toriginal'] = audiolibrary[index]['t'].join(" ").replaceAll('«','“').replaceAll('«','“').replaceAll('»','”').replaceAll('»','”')
                // audiolibrary[index]['t'] = this.removeArtifacts(audiolibrary[index]['t'].join(" "))
                

              //   if (audiolibrary[index]['key'].includes('phrasebook-')) {
              //     phrasebookaudio3.push(audiolibrary[index])
              //   } else if (audiolibrary[index]['key'].includes('_')) {
              //     conversational2.push(audiolibrary[index])
              //   } else {
              //     examplesentenceaudio1.push(audiolibrary[index])
              //   }
              // })

              // let oneandtwo = [...examplesentenceaudio1,...conversational2]
              // let twoandthree = [...conversational2,...phrasebookaudio3]
              // let oneandthree = [...examplesentenceaudio1,...phrasebookaudio3]
              // audiolibrary.map((k,index)=> audiolibrary[index]['enormal'] = audiolibrary[index]['e'].join(' ').replaceAll('k̲','k').replaceAll('x̲','x'))
              // audiolibrary.map((k,index)=> audiolibrary[index]['e'] = audiolibrary[index]['e'].join(" ").replaceAll('k̲','k').replaceAll('x̲','x'))
              // console.log('Processed AudioLibrary Normalized')
              // this.setState({examplesentenceaudio1:examplesentenceaudio1, conversational2:conversational2, phrasebookaudio3: phrasebookaudio3, oneandtwo: oneandtwo, twoandthree: twoandthree, oneandthree: oneandthree, audiolibrary: audiolibrary });
              this.setState({audiolibraryinterview: allsugtstundata['interview'], audiolibraryscripted:allsugtstundata['scripted'], audiolibrary:combinedAudioList, dictionary:dictionary, postbasedictionary:postbasedictionary,  dictionarydict:dictionarydict });
            });
        }
        else {
          this.setState({audiolibraryinterview: allsugtstundata['interview'], audiolibraryscripted:allsugtstundata['scripted'], audiolibrary:combinedAudioList, dictionary:dictionary, postbasedictionary:postbasedictionary, dictionarydict:dictionarydict });
          // this.setState({examplesentenceaudio1:examplesentenceaudio1, conversational2:conversational2, phrasebookaudio3: phrasebookaudio3, oneandtwo: oneandtwo, twoandthree: twoandthree, oneandthree: oneandthree, audiolibrary: audiolibrary });
        }



        // if (Object.keys(totaldata).length === 0) {
        //   this.reloadDownloadedData()
        // } else {
        //   console.log('used cached?')
        //   // this.setState({siuTable:siuTable,siuSearchList:siuSearchList})
        // }
      }

      // reloadKingikData = () => {
      //   console.log('reloading')
      //     axios
      //     .get(API_URL + "reloadKingikDataDownload")
      //     .then(response => {
      //       this.reloadDownloadedData()
      //       console.log(response.data);
      //     });
      //   }


      // reloadDownloadedData = () => {
      //     axios
      //       .get(API_URL + "kingikData", {
      //         // onDownloadProgress: (progressEvent) => {
      //         //   this.setState({progressData1:Math.round( progressEvent.loaded )})
      //         // },
      //       }).then(response => {
      //         totaldata = response.data;
      //         console.log(totaldata)
      //         // let dictionaryEntry = {}
      //         // let tlingitAudioKeys = {}
      //         console.log('Fetched urlDictionary');
      //         Object.keys(totaldata['siuTable']).forEach(k => {
      //           let tempdict = totaldata['siuTable'][k]
      //           tempdict['id']=k
      //           if (!('qaw' in tempdict)) {
      //             tempdict['qaw']=''
      //           }
      //           if (!('audio' in tempdict)) {
      //             tempdict['audio']={}
      //           }
      //           if (!('qik' in tempdict)) {
      //             tempdict['qik']=''
      //           }
      //           if (!('utq' in tempdict)) {
      //             tempdict['utq']=''
      //           }
      //           if (!('qig' in tempdict)) {
      //             tempdict['qig']=''
      //           }
      //           if (!('zoom' in tempdict)) {
      //             tempdict['zoom']=''
      //           }
      //           if (!('docs' in tempdict)) {
      //             tempdict['docs']=''
      //           }
      //           if (!('notes' in tempdict)) {
      //             tempdict['notes']=''
      //           }
      //           if (!('categories' in tempdict)) {
      //             tempdict['categories']=[]
      //           }
      //           if (!('sType' in tempdict)) {
      //             tempdict['sType']=''
      //           }
      //           if (tempdict['k'] !== null && tempdict['e'] !== null && tempdict['k'].length != 0 && tempdict['e'].length != 0) {
      //             siuSearchList.push(tempdict)
      //           }
      //             })
      //             let zoomSearchList = []
      //             let allpresenters = []
      //             let allspeakers = []
      //             let allstories = []
      //             let alltopics = []
      //             let allpresenters1 = []
      //             let allspeakers1 = []
      //             let allstories1 = []
      //             let alltopics1 = []
      //             Object.keys(totaldata['videoList']).forEach(k => {
      //               let kvalue = totaldata['videoList'][k]
      //               let subID = totaldata['videoList'][k]['subtitleID']
      //               if (kvalue['category']=='Zoom Session') {
      //                 if ('presenters' in kvalue) {
      //                   kvalue['presenters'].map((j)=>{
      //                     if (allpresenters.includes(j) && !allpresenters1.includes(j)) { //ONLY IF MORE THAN ONCE
      //                       allpresenters1.push(j)                            
      //                     }
      //                     if (!allpresenters.includes(j) && j.length != 0) {
      //                       allpresenters.push(j)
      //                     }
      //                   })
      //                 } else {
      //                   totaldata['videoList'][k]['presenters']=[]
      //                 }
      //                 if ('speakers' in kvalue) {
      //                   kvalue['speakers'].map((j)=>{
      //                     if (allspeakers.includes(j) && !allspeakers1.includes(j)) { //ONLY IF MORE THAN ONCE
      //                       allspeakers1.push(j)                            
      //                     }
      //                     if (!allspeakers.includes(j) && j.length != 0) {
      //                       allspeakers.push(j)
      //                     }
      //                   })
      //                 } else {
      //                   totaldata['videoList'][k]['speakers']=[]
      //                 }
      //                 if ('stories' in kvalue) {
      //                   kvalue['stories'].map((j)=>{
      //                     if (allstories.includes(j) && !allstories1.includes(j)) { //ONLY IF MORE THAN ONCE
      //                       allstories1.push(j)                            
      //                     }
      //                     if (!allstories.includes(j) && j.length != 0) {
      //                       allstories.push(j)
      //                     }
      //                   })
      //                 } else {
      //                   totaldata['videoList'][k]['stories']=[]
      //                 }
      //                 if ('topics' in kvalue) {
      //                   kvalue['topics'].map((j)=>{
      //                     if (alltopics.includes(j) && !alltopics1.includes(j)) { //ONLY IF MORE THAN ONCE
      //                       alltopics1.push(j)                            
      //                     }
      //                     if (!alltopics.includes(j) && j.length != 0) {
      //                       alltopics.push(j)
      //                     }
      //                   })
      //                 } else {
      //                   totaldata['videoList'][k]['topics']=[]
      //                 }
      //                 if (!('summary' in kvalue)) {
      //                   totaldata['videoList'][k]['summary']=""
      //                 }    
      //                 Object.keys(totaldata['srts'][subID[0]][subID[1]]).forEach(s => {
      //                   let transcript = ''
      //                   let speaker = ''
      //                   if (totaldata['srts'][subID[0]][subID[1]][s]['transcript'].includes(':')) {
      //                     speaker = totaldata['srts'][subID[0]][subID[1]][s]['transcript'].split(':')[0]
      //                     transcript = totaldata['srts'][subID[0]][subID[1]][s]['transcript'].split(':')[1]
      //                   } else {
      //                     speaker = ""
      //                     transcript = totaldata['srts'][subID[0]][subID[1]][s]['transcript']
      //                   }
      //                   zoomSearchList.push({'speaker':speaker,'t':s,'transcript':transcript,'date':kvalue['date'],'url':k})
      //                 })
      //               }
      //             })
      //             this.setState({allfilters:{'presenters':allpresenters1,'stories':allstories1, 'speakers':allspeakers1, 'topics':alltopics1}, zoomSearchList:zoomSearchList, inupiaqPopups:totaldata['inupiaqPopups'],videoList:totaldata['videoList'],srts:totaldata['srts'],siuTable:totaldata['siuTable'],siuSearchList:siuSearchList})

      //           });        
      // }

      componentWillUnmount() {
        window.removeEventListener("resize", this.updateDimensions);
      }

      audioHandler() {
        this.setState({audioOnly:!this.state.audioOnly})
      }

      handleItemClick = (e, { name, id }) => {
        this.setState({ 
          activeItem: name, 
        })
      }

      updateDimensions() {
        this.setState({
          innerWidth: document.documentElement.clientWidth,
          innerHeight: document.documentElement.clientHeight,
        });
      }

      render() {
        // console.log(this.state)
        const { activeItem } = this.state
        return(
        <div className='app'>

          <Switch>

            {this.state.dictionary.length !== 0 && this.state.audiolibrary.length !== 0 ?
              <div>
                <Route exact path='/search' render={(props) => <Home {...props} audiolibrary={this.state.audiolibrary} audiolibraryscripted={this.state.audiolibraryscripted} audiolibraryinterview={this.state.audiolibraryinterview} dictionary={this.state.dictionary} postbasedictionary={this.state.postbasedictionary} dictionarydict={this.state.dictionarydict} />} />
                <Route exact path='/recorder' render={(props) => <Recorder {...props} />} />
                <Route exact path='/validate' render={(props) => <Validate {...props} />} />
                <Route exact path='/report' render={(props) => <Report {...props} />} />
                <Route exact path='/legend' render={(props) => <Legend {...props} />} />
                {/*<Route exact path='/search' render={(props) => <Search {...props} siuSearchList={this.state.siuSearchList} siuTable={this.state.siuTable} />} />*/}
                <Route exact path='/zoomlist' render={(props) => <ZoomList {...props} videoList={this.state.videoList} allfilters={this.state.allfilters} zoomSearchList={this.state.zoomSearchList} />} />
                <Route exact path='/zoomsearch' render={(props) => <ZoomSearch {...props} videoList={this.state.videoList} zoomSearchList={this.state.zoomSearchList} />} />
                <Route exact path='/search/:word' render={(props) => <Entry {...props} audiolibrary={this.state.audiolibrary} audiolibraryscripted={this.state.audiolibraryscripted} audiolibraryinterview={this.state.audiolibraryinterview} dictionary={this.state.dictionary} dictionarydict={this.state.dictionarydict} />}/>
                <Route exact path='/video/:word' render={(props) => <Video {...props} inupiaqPopups={this.state.inupiaqPopups} videoList={this.state.videoList} srts={this.state.srts} />} />
              </div>
              :
              <div>
                <Dimmer style={{height:400}} active inverted>
                  <Loader style={{marginTop:-((870-window.innerHeight)/2)}} size='massive'>
                    Loading...
                  <Progress style={{marginTop:20}} percent={this.state.fullProgress} size='tiny' />
                  </Loader>
                </Dimmer>
              </div>
            }

          </Switch>

        </div>
        );
      }
    };

    export default App;
